import { Drawer as MuiDrawer } from '@mui/material'
import { styled } from '../../utils/styled'
import Grid from '../Grid'
import type { DrawerAnchor } from './types'

const DRAWER_TRANSITION =
  'width 225ms cubic-bezier(0, 0, 0.2, 1), min-width 225ms cubic-bezier(0, 0, 0.2, 1), height 225ms cubic-bezier(0, 0, 0.2, 1)'

const INSET_BORDER_BY_ANCHOR: Record<DrawerAnchor, string> = {
  right: 'inset 1px 0 0 0',
  left: 'inset -1px 0 0 0',
  bottom: 'inset 0 1px 0 0',
  top: 'inset 0 -1px 0 0'
}

export const StyledDrawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => !['drawerWidth', 'drawerHeight', 'isResizing'].includes(prop as string)
})<{
  anchor: DrawerAnchor
  drawerWidth: number | string
  drawerHeight: number | string
  isResizing: boolean
}>(({ theme, anchor, drawerWidth, drawerHeight, isResizing }) => ({
  width: drawerWidth,
  minWidth: drawerWidth,
  height: drawerHeight,
  transition: isResizing ? 'none' : DRAWER_TRANSITION,
  '& .MuiDrawer-paper': {
    width: '100%',
    height: '100%',
    boxSizing: 'border-box',
    position: 'relative',
    background: 'transparent',
    border: 'none',
    boxShadow: `${INSET_BORDER_BY_ANCHOR[anchor]} ${theme.tokens.border.main.tonal}`,
    padding: '20px 24px 12px 24px'
  }
}))

export const StyledResizeHandle = styled(Grid, {
  shouldForwardProp: (prop) => !['anchor', 'isHorizontal'].includes(prop as string)
})<{ anchor: DrawerAnchor; isHorizontal: boolean }>(({ theme, anchor, isHorizontal }) => {
  return {
    position: 'absolute',
    zIndex: theme.zIndex.drawer,
    '&:hover, &:active': {
      backgroundColor: theme.tokens.background.brand.main.default
    },
    ...(isHorizontal
      ? {
          top: 0,
          bottom: 0,
          left: anchor === 'right' ? 0 : 'auto',
          right: anchor === 'left' ? 0 : 'auto',
          width: '4px',
          height: '100%',
          cursor: 'ew-resize'
        }
      : {
          top: anchor === 'bottom' ? 0 : 'auto',
          bottom: anchor === 'top' ? 0 : 'auto',
          left: 0,
          right: 0,
          width: '100%',
          height: '4px',
          cursor: 'ns-resize'
        })
  }
})

export const StyledDrawerHeader = styled(Grid)({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px'
})

export const StyledDrawerHeaderRow = styled(Grid)({
  height: '48px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between'
})

export const StyledCloseButton = styled('div')({
  alignSelf: 'unset'
})
